import styled, { css } from 'styled-components'

import Image from 'shared/components/Image'
import { CMSColumnBlockSection } from 'shared/enums/CMSColumnBlockSection'
import { media } from 'shared/lib'
import { ArticleImageSet } from 'shared/types/ArticleImageSet'
import { ArticleColumnBlockSection } from 'shared/types/ArticleColumnBlockSection'

type ColumnBlockSectionProps = {
  section: ArticleColumnBlockSection
}

const ColumnBlockSection = ({ section }: ColumnBlockSectionProps) => {
  if (!section || !section?.type) {
    return null
  }

  if (section?.type === CMSColumnBlockSection.OneColumnBlockSection) {
    return (
      <StyledImage
        $sectionType={section?.type}
        alt={section?.mediaAsset?.imageFileName}
        data-qa="OneColumnBlockSectionImage"
        fill
        sizes="100vw"
        src={section?.mediaAsset?.largeUrl}
      />
    )
  }

  // section?.type === CMSColumnBlockSection.TwoColumnBlockSection
  return (
    <TwoColumnContainer $hasMargin={section?.hasMargin}>
      <StyledImage
        $hasMargin={section?.hasMargin}
        $sectionType={section?.type}
        alt={section?.firstPicture?.imageFileName}
        data-qa="TwoColumnBlockSectionFirstImage"
        fill
        sizes="50vw"
        src={section?.firstPicture?.largeUrl}
      />
      <StyledImage
        $hasMargin={section?.hasMargin}
        $sectionType={section?.type}
        alt={section?.secondPicture?.imageFileName}
        data-qa="TwoColumnBlockSectionSecondImage"
        fill
        sizes="50vw"
        src={section?.secondPicture?.largeUrl}
      />
    </TwoColumnContainer>
  )
}

type ArticleImageSetSectionProps = {
  section: ArticleImageSet
}

export const ArticleImageSetSection = ({ section }: ArticleImageSetSectionProps) => {
  if (!section?.subsections || section?.subsections?.length === 0) {
    return null
  }

  return (
    <Container>
      {section?.subsections?.map((subsection) => (
        <ColumnBlockSection key={subsection?.uuid} section={subsection} />
      ))}
    </Container>
  )
}

const DESKTOP_PADDING = 40
const MOBILE_PADDING = 24
const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 120px;
  margin-top: 120px;
  width: 100vw;

  ${media.medium`
    margin-bottom: 240px;
    margin-top: 240px;
  `};
`
const StyledImage = styled(Image)<{ $hasMargin?: boolean; $sectionType?: string }>`
  height: auto !important;
  margin-top: -2px;
  max-height: none !important;
  position: static !important;

  ${({ $hasMargin, $sectionType }) => {
    if ($sectionType === CMSColumnBlockSection.OneColumnBlockSection) {
      return css`
        width: 100vw !important;
      `
    }

    /* $sectionType === CMSColumnBlockSection.TwoColumnBlockSection */
    if ($hasMargin) {
      return css`
        width: calc(100vw - ${2 * MOBILE_PADDING}px) !important;

        ${media.medium`
            width: calc(50vw - ${DESKTOP_PADDING}px) !important;
          `}
      `
    }

    return css`
      width: 100vw !important;

      ${media.medium`
        width: 50vw !important;
      `}
    `
  }}
`
const TwoColumnContainer = styled.div<{ $hasMargin?: boolean }>`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr 1fr;

  ${media.medium`
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr;
  `}

  ${({ $hasMargin }) =>
    $hasMargin &&
    css`
      padding: ${MOBILE_PADDING}px;

      ${media.medium`
        padding: ${DESKTOP_PADDING}px;
      `}
    `}
`
